import React from 'react';
import './../App.css';
import BlueTicket from '../Components/BlueTicket';
import Search from '../Components/Search';
import Article from '../Components/Article';
import Editor from '../Components/Editor';
import SideBar from '../Components/SideBar';
import methodsOneContext from '../Contexts/MethodsOne';
import GoodsContainer from '../Components/GoodsContainer'
import PartialSite1 from '../Components/PartialSite1';
import ScrollAnimation from 'react-animate-on-scroll';
// import Scrollspy from 'react-scrollspy'


export default class App extends React.Component {
  constructor(props) {
    super(props);
    console.log(this.props.history.location.pathname);
  }
  
  state = {
    detailList : [],
    editId : -1
   }

   componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }

   setDetailList(data){

      this.setState(prevState => {
        return {
          detailList : data,
          editId : -1
        }
      })

   }

   editDetail(id){
    this.setState(prevState => {
      return {
        editId : id
      }
    })
  }

    newEvent(){
      this.setState(prevState => {
        return { 
          detailList : [{Id:0 ,Description:'', Tag:''}],
          editId : 0
        }
      })

    console.log('رسsadadsadیدم');
    console.log(this.state);
    console.log(this.state.detailList);

   }

  render() {
    let detailList = this.state.detailList;
    let editId = this.state.editId;
    return (

      <>
      
                <div class="header_section">
                <div class="maz-bg-container ">
                <div class="container">
                <ScrollAnimation animateIn="fadeIn">
                <section class="maz-textSection clearfix">
                <article>
                    <div class="row">
                        <div class="maz-col-xs-12 maz-list2">
                            <img class="maz-icon-bullet2 maz-img-responsive" src={require('./../img/icon-bullet2.png')}/>
                            <h2>همکاری با بیت کالا</h2>
                            <p class="maz-pad-txt1 ">
                                شرکت بیت کالا تولید کننده سامانه ها و نرم افزارهای اتوماسیون اداری، همواره در جهت جذب و رشد استعدادهای افراد متخصص و توانا کوشا بوده است . افرادی که مایل به همکاری با شرکت بیت کالا هستند باید دارای شرایط زیر باشند:
                            </p>
                        </div>
                    </div>
                    <div class="row ">
                        <div class="maz-col-xs-12 maz-list1 ">

                            <ul>
                                <li>داشتن نظم ، دقت عمل و پشتکار</li>
                                <li>داشتن روحیه تعامل وهمکاری و کارگروهی </li>
                                <li>تعهد ، امانت داری و پایبندی به اصول اخلاقی</li>
                                <li>توانایی انجام کار بلند مدت و تمام وقت</li>
                                <li>تخصص و مهارت در حیطه کاری مربوطه</li>
                            </ul>
                        </div>

                    </div>
                    <div class="row maz-pad-txt1">
                        <div class="maz-col-xs-12  maz-list2">
                            <img class="maz-icon-bullet2 maz-img-responsive" src={require('./../img/icon-bullet2.png')}/>
                            <h2>زمینه های کاری شرکت بیت کالا</h2>
                            <p class="maz-pad-txt1">شرکت بیت کالا ، در زمینه های  زیر و با مهارتهای ذکر شده، علاقمند به جذب نیرو میباشد :</p>
                            <h3 class="txt">1- برنامه نویس </h3>
                            <ul>
                                <li>تسلط به برنامه نویسی با Javascript و  Jquery</li>
                                <li>تسلط به برنامه نویسی با #Asp.net , C  </li>
                                <li>برنامه نویسی تحت وب با محصولات مایکروسافت دات نت   </li>
                                <li>طراحی و پیاده سازی بانکهای اطلاعاتی توسط MS Sql Server </li>
                                <li>تحلیل ، طراحی و مدل سازی سازی </li>
                                <li>تجربه در طراحی امنیت سیستمهای نرم افزاری و شبکه ای</li>

                            </ul>
                            <h3 class="txt">2- کارآموز </h3>
                            <ul>
                                <li>
قصد داریم جهت توسعه تیم فنی خود از میان کارشناسان با انگیزه و علاقه مند که آشنایی کافی با برنامه نویسی ASP.NET MVC دارند نفراتی را انتخاب ، و پس از دوره کارآموزی به دپارتمان فنی بیت کالا معرفی نماییم. 
                                   
                                  در طول این دوره تستها و تمرینهایی با رویکرد عملیاتی اجرا خواهد شد که در ارتقاء توان علمی و تجربی کارآموزان تاثیر قابل توجهی خواهد داشت . 

                                   </li><li>
1) توسعه اپلیکیشن تحت وب (MVC)  
                                       </li>
                                    <li>

2) کار با EF و ORM 
                                        </li>
                                    <li>
3) طراحی جداول پایگاه داده 
                                        </li>
                                    <li>
4) کسب مهارت در SQL Server 
                                        </li>
                                    <li>
5) زبان های JavaScript, JQuery  
                                     </li>
                                

                            </ul>
                            <p>
                                چنانچه در هریک از زمینه های فوق ، مایل به همکاری با این شرکت باشید ، میتوانید با ارسال 
رزومه خود به آدرس <span class="txt1">jobs@bitkala.ir</span> با ما ارتباط برقرار سازید .
                            </p>
                            <p class="info">
                                اطلاعات ارسالی رزومه شما ، در شرکت بیت کالا به عنوان اطلاعات محرمانه ثبت خواهد شد.
                            </p>
                        </div>

                    </div>
                </article>
            </section>
            </ScrollAnimation>
                </div>
                </div>
                </div> 

      </>
    )
  }
}


